import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '15px 25px',
    background: 'white',
    height: '64px',
    borderBottom: `1px solid ${theme.palette.grey.grey200}`
  },
  backButton: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  backArrow: {
    marginRight: '32px'
  },
  backButtonText: {
    color: theme.palette.black.dark,
    fontSize: '16px',
    fontWeight: 600,
  },
  contextIcon: {
    marginRight: '11px'
  },
}));

export default useStyles;
